import moment from "moment";
import { constraintsOptions, datatypes, inputTypes, objType } from "data/globalData";
import CustomTextField from "../CustomTextfield/CustomTextfield";
import SelectInputField from "../SelectInputField/SelectInputField";

const RenderInputField = ({ column, setData, data, width, selectOptObjName, dependencyColData, disabled, minDateTime }) => {
	width = column?.data_type === datatypes.LONGTEXT.key ? "74%" : width ? width : "24%";
	if (column?.data_type === datatypes.DATE.key) {
		data = { ...data, [data[column.group][column.key]]: moment(data[column.group][column.key]).format("YYYY-MM-DD") };
	}
	const options = column[selectOptObjName] ? column[selectOptObjName] : { type: objType, list: {} };
	const handleChange = async (e) => {
		let obj = { ...data };
		obj[column.group] = {
			...(obj[column.group] || {}),
			[column.key]: e.target.value,
		};
		setData(obj);
	};

	const handleDateTimestampChange = async (newValue) => {
		let obj = { ...data };
		obj[column.group] = {
			...(obj[column.group] || {}),
			[column.key]: newValue,
		};
		setData(obj);
	};

	if (column)
		if (column.input_type === inputTypes.ENTER.key || column.input_type === inputTypes.AUTO_GENERATE.key) {
			return (
				column?.constraints[constraintsOptions.DISPLAY.key] && (
					<CustomTextField
						variant={"outlined"}
						data={data[column.group]}
						disabled={column?.input_type === inputTypes.AUTO_GENERATE.key || disabled}
						setData={setData}
						onChange={column?.data_type != "DATE_TIMESTAMP" ? handleChange : handleDateTimestampChange}
						column={column}
						width={column?.data_type?.includes("long") ? "70%" : width}
						required={column?.constraints[constraintsOptions.NOTNULL.key] ? true : false}
						type={column?.data_type}
						minDateTime={minDateTime}
					/>
				)
			);
		} else {
			return (
				column?.constraints[constraintsOptions.DISPLAY.key] && (
					<SelectInputField
						// sx={{ width: "55%", p: 1, background: grey[200], fontWeight: 400, overflow: "hidden" }}
						data={data[column.group]}
						setData={setData}
						column={column}
						width={width}
						onChange={handleChange}
						options={options}
						required={column?.constraints[constraintsOptions.NOTNULL.key] ? true : false}
						disabled={disabled}
					/>
				)
			);
		}
};

export default RenderInputField;
